import { useEffect, useState } from "react";
import axios from "axios";
import logo from "../assets/logo.png";
import bg from "../assets/bg-latest.png";

function Video() {
  const [mediaItems, setMediaItems] = useState([]);
  const apiEndpoint =
    "https://dfapi.tagg.live/campaign/mpidc/users/latest?limit=20&skip=0";

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(apiEndpoint);
        const users = response.data.users || [];
        const items = users
          .map((user) => ({
            url: user.output_link,
            type: user.output_link?.endsWith(".mp4") ? "video" : "photo",
            name: user.attributes.name || "",
            gender: user.attributes.gender || "",
            createdAt: user.created_at,
          }))
          .filter((item) => item.url != null);
        setMediaItems(items);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchUsers();
    const intervalId = setInterval(fetchUsers, 20000);
    return () => clearInterval(intervalId);
  }, []);

  const frameColors = [
    "from-teal-300 to-sky-300", // turquoise
    "from-blue-300 to-indigo-300", // blue
    "from-amber-300 to-yellow-300", // golden
    "from-rose-300 to-pink-300", // coral
    "from-emerald-300 to-teal-300", // mint
    "from-yellow-300 to-amber-300", // yellow
    "from-orange-300 to-rose-300", // orange
    "from-teal-300 to-emerald-300", // seafoam
  ];

  return (
    <div
      className="relative w-[1920px] h-[1080px] overflow-hidden"
      style={{ backgroundImage: `url(${bg})` }}
    >
      {/* Logo */}
      <div className="absolute top-6 left-6 w-40 h-40">
        <img
          src={logo}
          alt="Invest Madhya Pradesh Logo"
          className="object-contain"
        />
      </div>

      {mediaItems.length > 0 && (
        <div className="absolute top-[63%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1500px]  grid grid-cols-5 gap-6">
          <div className="col-span-2 grid grid-cols-2 grid-rows-2 gap-6 h-[79%]">
            {[0, 1, 2, 3].map((index) => {
              const mediaItem = mediaItems?.[index];
              const frameColor = frameColors?.[index] || "bg-gray-300";

              return (
                <div
                  key={index}
                  className={`relative rounded-[32px] p-1.5 bg-gradient-to-br ${frameColor} shadow-lg`}
                >
                  <div className="relative h-full rounded-[28px] overflow-hidden">
                    {mediaItem?.type === "video" && mediaItem?.url ? (
                      <video
                        src={mediaItem.url}
                        className="w-full h-full object-cover"
                        autoPlay
                        loop
                        muted
                        playsInline
                        controls={false}
                        onError={(e) => {
                          console.error("Video error:", e);
                          console.log("Failed video URL:", mediaItem.url);
                        }}
                      />
                    ) : (
                      <img
                        src={mediaItem?.url || "/placeholder.svg"}
                        alt={mediaItem?.name || "Placeholder"}
                        className="w-full h-full object-cover"
                        onError={(e) => (e.target.src = "/placeholder.svg")}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Center Column (Large Image) */}
          <div className="h-full">
            <div
              className={`relative rounded-[40px] p-1.5 bg-gradient-to-br w-full h-[79%] ${frameColors[2]} shadow-lg`}
            >
              <div className="relative rounded-[36px] overflow-hidden h-full">
                {mediaItems[4]?.type === "video" ? (
                  <video
                    src={mediaItems[4].url}
                    className="object-cover h-full"
                    autoPlay
                    loop
                    muted
                    playsInline
                    controls={false}
                    onError={(e) => {
                      console.error("Video error:", e);
                      console.log("Failed video URL:", mediaItems[4].url);
                    }}
                  />
                ) : (
                  <img
                    src={mediaItems[4]?.url || "/placeholder.svg"}
                    alt={mediaItems[4]?.name}
                    className="object-cover"
                  />
                )}
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-span-2 grid grid-cols-2 grid-rows-2 gap-6 h-[79%]">
            {[5, 6, 7, 8].map((index) => {
              const mediaItem = mediaItems?.[index];
              const frameColor = frameColors?.[index] || "bg-gray-300";

              return (
                <div
                  key={index}
                  className={`relative rounded-[32px] p-1.5 bg-gradient-to-br ${frameColor} shadow-lg`}
                >
                  <div className="relative h-full rounded-[28px] overflow-hidden">
                    {mediaItem?.type === "video" && mediaItem?.url ? (
                      <video
                        src={mediaItem.url}
                        className="object-cover"
                        autoPlay
                        loop
                        muted
                        playsInline
                        controls={false}
                        onError={(e) => {
                          console.error("Video error:", e);
                          console.log("Failed video URL:", mediaItem.url);
                        }}
                      />
                    ) : (
                      <img
                        src={mediaItem?.url || "/placeholder.svg"}
                        alt={mediaItem?.name || "Placeholder"}
                        className="object-cover"
                        onError={(e) => (e.target.src = "/placeholder.svg")}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="absolute  flex items-center justify-center w-full bottom-[15%] gap-8 text-[#1E5898] font-semibold text-4xl">
            <p>Be a part of #myMPstory </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Video;
